<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">Lead Source Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>ID:</td>
                  <td>
                    {{ legalModel.id ? legalModel.id : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>
                    {{ legalModel.name ? legalModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Lead Source Logo</td>
                  <td>
                    {{
                      legalModel.profilePicture ? legalModel.profilePicture : ""
                    }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New Lead Source</v-btn
            >
            <v-btn
              v-else
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Legal } from "@/models/Legal";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      legalModel: new Referral(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "Lead Sources",
          disabled: false,
          href: "/admin/legal",
        },
        {
          text: "Lead Source Details",
          disabled: true,
          href: `/admin/referral/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    referral: {
      query: gql`
        query Referral($id: ID!) {
          referral(id: $id) {
            id
            name
            profilePicture
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.legalModel.id = this.referral.id;
        this.legalModel.name = this.referral.name;
        this.legalModel.profilePicture = this.referral.profilePicture;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
